import { Observable } from 'rxjs';
import {
  AddManualLocationRequest,
  Filter,
  PostalCode,
  PrivateLocatioDetails,
  Product,
  PublicLocation,
  PublicLocationRequest,
  Tag,
} from '../domain';
import { LocationImportRequest } from '../domain/requests/locations/location-import.request';
import { LocationImport } from '../domain/models/location-import.model';
import { SelectedSegmentId } from '../domain/models/private-location/selected-building-block-id';
import { LocationType } from '../domain/models/location-type';
import { ProductActivity } from '../domain/models/product-activity';

export abstract class MasterlocationRepository {
  abstract getSegmentIds(): Observable<SelectedSegmentId[]>;


  abstract getPostalCodes(): Observable<PostalCode[]>;

  abstract getTags(): Observable<Tag[]>;

  abstract getFilters(): Observable<Filter[]>;

  abstract getPublicLocations(
    request: PublicLocationRequest
  ): Observable<PublicLocation[]>;

  abstract getLocationImport(
    request: LocationImportRequest
  ): Observable<LocationImport[]>;
  
  abstract getPublicLocationsForAutoComplete(
    request: PublicLocationRequest
  ): Observable<PublicLocation[]>;

  abstract getPrivateLocationsDetails(
    request: string
  ): Observable<PrivateLocatioDetails>;
  
  abstract importPlanContainerLocationCSV(request: FormData): Observable<boolean>;
  abstract deleteMasterLocation(request: string): Observable<boolean>;

  abstract addManualLocation(request: AddManualLocationRequest): Observable<boolean>
  abstract getLocationTypes(): Observable<LocationType[]>;
  abstract getActivitiesByProduct(productId: string): Observable<ProductActivity[]>;

}
